import { ReportOrgan } from '@/api';
import { useIsDDFeatureFlagEnabled } from '@/core/data-dog';
import { OrganName, useReportOrganStore } from '@/store';

import { useFctReport } from './use-fct-report.hook';
import { useReportOrgansMapFromQuery } from './use-report-organs-map-from-query.hook';

export function useReportOrgansMap(): Record<OrganName, ReportOrgan> | undefined {
  const { report } = useFctReport();

  const reportUuid = report?.uuid || '';
  const isRqReportOrganEnabled = useIsDDFeatureFlagEnabled('FCT_RQ_REPORT_ORGAN');
  const reportOrgansMapFromStore = useReportOrganStore((state) => state.reportOrgans[reportUuid]);
  const reportOrgansMapFromQuery = useReportOrgansMapFromQuery(reportUuid);

  const reportOrgansMap = isRqReportOrganEnabled
    ? reportOrgansMapFromQuery
    : reportOrgansMapFromStore;

  return reportOrgansMap;
}
